"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentsByCustomerCard = void 0;
const react_1 = __importDefault(require("react"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const useDebouncedState_1 = require("../../../utils/useDebouncedState");
const CommentsByCustomerCard = (props) => {
    var _a;
    // Debounce changes to speed up editing experience.
    const [debouncedComments, setDebouncedComments] = (0, useDebouncedState_1.useDebouncedState)(props.booking.commentsByCustomer, (commentsByCustomer) => props.onBookingChange({ commentsByCustomer }), 300, { leading: true });
    return (react_1.default.createElement(Card_1.default, { className: (_a = props.className) !== null && _a !== void 0 ? _a : "" },
        react_1.default.createElement(Card_1.default.Body, null,
            react_1.default.createElement(Form_1.default.Group, { controlId: "booking-commentsByCustomer", className: "h-100 mb-0 d-flex flex-column" },
                react_1.default.createElement(Form_1.default.Label, null, "Bemerkungen Kunde"),
                react_1.default.createElement(Form_1.default.Control, { className: "flex-grow-1", as: "textarea", rows: 5, value: debouncedComments, onChange: (e) => setDebouncedComments(e.target.value.slice(0, 2000)), readOnly: !props.editable })))));
};
exports.CommentsByCustomerCard = CommentsByCustomerCard;
